import React from 'react';
import { Users, Heart, Star, ShieldCheck } from 'lucide-react';
import { STATS } from '../mock';

const ICONS = { Users, Heart, Star, ShieldCheck };

const Stats = () => (
  <section className="stats-band" data-testid="stats-band">
    <div className="container">
      <div className="stats">
        {STATS.map((s) => {
          const Ic = ICONS[s.icon];
          return (
            <div className="stat" key={s.label}>
              <div className="s-icon"><Ic size={22} /></div>
              <div>
                <b>{s.value}</b>
                <span>{s.label}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default Stats;
